import { Route } from 'vue-router'
import { URLS } from '@/router/routes/urlRoutes'
import store from '@/store/store'
import { ModuleNamespaces } from '@/store/types/storeGlobalTypes'

export const searchIAGuard = (to: Route, _from: Route, next: any): void => {
  if (to.name !== URLS.SEARCH_IA) {
    return next()
  }

  const canAccessSearchIA: boolean = store.getters[`${ModuleNamespaces.AUTH}/getShowSearchIA`]

  if (!canAccessSearchIA) {
    return next({ name: URLS.DASHBOARD })
  }

  return next()
}
